import { render } from "./Contact.vue?vue&type=template&id=3b5dfb6a"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=3b5dfb6a&lang=scss"
script.render = render

export default script